module.exports = __webpack_public_path__ + "static/img/up3.015a6bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/up3.png
// module id = H+GW
// module chunks = 1